const Resources = {

    table_headers: [
        { 
          text: 'Number #',
          align: 'start',
          value: 'number',
          type:  'link'
        },
        { 
            text: 'Description',
            value: 'description',
            type:   'link',
        },
        { 
            text: 'Start time',
            value: 'formatted_start_time'
        },
        {   
            text: 'End time',
            value: 'formatted_end_time'
        },
        { 
            text: 'Total Hours',
            value: 'total_time',
            type:   'hours',
        },
        { 
            text: 'Total minutes',
            value: 'total_minutes',
        },
        { 
            text: 'Work time',
            value: 'work_time',
        },
        { 
            text: 'Breaks counter',
            value: 'break_counter'
        },
    ],

    deletion_validation_table_headers: [
        { 
          text:     'Shift',
          align:    'start',
          value:    'name',
        },
        {
            text:   '# of daily assignments',
            value:  'associated_models_count',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Shifts',
            href:   '/assignment-shifts',
            arrow:  "",
        },
    ],

    excel_file_headers: {
        'Number': 'number',
        'Description': 'description',
        'Class': 'class',
        'Prep minutes': 'prep_minutes',
        'Cleanup minutes': 'clenaup_minutes',
        'Start time': 'start_time',
        'End time' : 'end_time',
    },

    empty_format_data: [
        {
            number:             '',
            description:        '',
            class:              'Day',
            prep_minutes:       '',
            start_time:         '00:00',
            end_time:           '01:00',
            clenaup_minutes:    '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Shift?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_New_Shift__sddYX09AT8y3gGdppA3E7w?as=scrollable`
        },
        {
            label: '¿How to delete a Shift?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_a_Shift__-Ql2VndQSlyxGGfS4tpnNA?as=scrollable`
        },
    ],

}

export default Resources;